export default [
    {
        path: '/mall/products',
        meta: {
          title: '全部商品',
        },
        component: () => import('@/views/mall/products/index.vue'),
      },
      {
        path: '/mall/operation-log',
        meta: {
          title: '操作日志',
        },
        component: () => import('@/views/mall/operation-log'),
      },
      {
        path: '/mall/category',
        meta: {
          title: '分类管理',
        },
        component: () => import('@/views/mall/Category'),
      },
      {
        path: '/mall/attrs',
        meta: {
          title: '商品规格属性',
        },
        component: () => import('@/views/mall/Attrs'),
      },
      {
        path: '/mall/ad',
        meta: {
          title: '广告管理',
        },
        component: () => import('@/views/mall/Ad'),
      },


      //-------其他
      {
        path: '/mall/freight',
        meta: {
          title: '运费模板'
        },
        component: () => import('@/views/mall/Freight.vue')
      },

      {
        path: '/supplier/product',
        meta: {
          title: '供货产品'
        },
        component: () => import('@/views/mall/products/index.vue')
      },
    
]
